/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

// Drawn 3D smoke/cloud layers (see .layerImage / .cloudSvg in MonsterDisplay.css). Each layer is an
// independent fractal-noise-lit cloud field that drifts in its own direction. Directions are spread
// evenly by index: with N layers, layer i drifts at i * 360/N degrees (so 5 layers => 72° apart, etc).
// Keep the count modest so individual cloud masses stay distinct (too many overlapping layers just
// blur into a flat haze). Each layer adds a one-time filter raster at load, so don't go overboard.
// Layers are lit in varying tones — some white, some grey — so they read as distinct, overlapping
// clouds with depth (greyer layers act like shadowed / lower clouds) rather than one uniform white.
export const CLOUD_DRIFT_DISTANCE = 12; // how far each layer drifts, in % of the (oversized) layer
export const CLOUD_TONES = ['#b6bfc9', '#e7ebef', '#666666', '#ffffff', '#d4dbe2'];
export const CLOUD_LAYER_COUNT = CLOUD_TONES.length;
export const CLOUD_LAYER_DEFS = Array.from({ length: CLOUD_LAYER_COUNT }, (_, i) => {
  const radians = (i * 360 / CLOUD_LAYER_COUNT) * Math.PI / 180;
  return {
    id: `cloudFilter${i}`,
    seed: i * 9 + 2,
    baseFrequency: (0.006 + (i % 3) * 0.003).toFixed(4),  // vary puff size across layers
    surfaceScale: (1.3 + (i % 3) * 0.35).toFixed(2),      // vary how 3D/shadowed each layer is
    tone: CLOUD_TONES[i % CLOUD_TONES.length],            // white vs grey, for depth/distinction
    dx: (Math.cos(radians) * CLOUD_DRIFT_DISTANCE).toFixed(2),
    dy: (Math.sin(radians) * CLOUD_DRIFT_DISTANCE).toFixed(2),
    grow: (1.12 + (i % 3) * 0.12).toFixed(2),
    durationS: 12 + (i % 5) * 3,   // ~12-24s, varied so layers desync (fast enough to notice)
    delayS: -(i * 5),              // negative delay offsets each layer's phase
    opacity: 0.5,                  // higher per-layer than before so each layer stays visible
  };
});
